import { cond, T, always, lte } from 'ramda'
import resources from '@/store/modules/resources'
import { path, isNil } from 'ramda'
import Raven from 'raven-js'

const unconfirmedMessage = [
  'Identificamos que você já está cadastrado. Enviamos um e-mail de confirmação.',
  "This e-mail is already in use but it's not confirmed. We just sent another confirm link, please check your inbox.",
]

export default error => {
  const whenUnconfirmed = (message => () =>
    unconfirmedMessage.includes(message))(error.response.data.message)

  // unauthorized custom survey
  if (
    error.response.status === 409 &&
    !isNil(path(['request', 'responseURL'], error)) &&
    error.request.responseURL.includes('custom-surveys')
  ) {
    return error.response.data.message
  }

  const pathExists = !isNil(path(['response', 'data'], error))
  if (!pathExists) return error
  const newMessage = cond([
    [lte(500), always(resources.state.resources.general.errors.response500)],
    [lte(409), always(resources.state.resources.general.errors.alreadyExists)],
    [whenUnconfirmed, always('UNCONFIRMED')],
    [T, always(error.response.data.message)],
  ])(error.response.status)

  error.response.data.message = newMessage

  const data =
    error.response.config && error.response.config.data
      ? JSON.parse(error.response.config.data)
      : null

  Raven.captureException(new Error(error.message), {
    extra: JSON.parse(JSON.stringify({ ...error.response, ...data })),
  })

  return error
}
